<template>
  <UApp :locale="ro">
    <NuxtLoadingIndicator />
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </UApp>
</template> 

<script setup lang="ts">
import { ro } from '@nuxt/ui/locale';

const { currentPage } = useNavigation();

useSeoMeta({
    title: () =>
      currentPage.value
        ? `${currentPage.value.title} | SC Compania de Apa Oradea SA`
        : "SC Compania de Apa Oradea SA",

    ogTitle: () =>
      currentPage.value
        ? `${currentPage.value.title} | SC Compania de Apa Oradea SA`
        : "SC Compania de Apa Oradea SA",
  });
</script>